<template lang="html">
  <div v-scroll="onScroll">
    <div v-if="noData && !loading" class="loader-container">
      <no-data-message>
        <v-icon slot="icon">event_note</v-icon>
        <template slot="message">
          There are no effort items to show
        </template>
        <template slot="sub-message">
          You can explore new effort from the button below
        </template>
        <template slot="button">
          <router-link :to="{name: 'Tasks', query: { browse_id: 1 }}">
            Find Effort
          </router-link>
        </template>
      </no-data-message>
    </div>

    <tasks-list v-else v-model="followingTasks"></tasks-list>
    <div v-if="loading" class="loader-container">
      <loader></loader>
    </div>
  </div>
</template>


<script>
import Loader from '@/components/Loader';
import TasksList from '@/components/shared/TasksList';

export default {
  components: {
    Loader,
    TasksList,
  },
  data() {
    return {
      lastScroll: 0,
    };
  },
  computed: {
    loading() {
      return this.$store.getters['tasks/followingTasksLoading'];
    },
    noData() {
      return this.followingTasks.length === 0;
    },
    followingTasks: {
      get() {
        return this.$store.getters['tasks/followingTasks'];
      },
      set(value) {
        this.$store.dispatch('tasks/reorderFollowingTasks', value);
      },
    },
  },
  methods: {
    onScroll() {
      const scroll = this.$scrollPercent();
      const scrollingUp = this.lastScroll > scroll;
      this.lastScroll = scroll;
      this.showFindEffortButton = scroll > 0.2;

      if (scroll < 0.90 || scrollingUp) return null;

      this.$store.dispatch('tasks/followingTasks');
      return null;
    },
  },
  mounted() {
    this.$store.dispatch('tasks/resetTasksFollowing');
    this.$store.dispatch('tasks/followingTasks');
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

#app {
  .centered {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .loader-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80%;
  }
}

.half-circle-spinner {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/TasksFollowing.vue